
import { Options, Vue } from 'vue-class-component';
import QRCodeStyling from './components/QRCodeStyling.vue';

@Options({
  components: {
    QRCodeStyling,
  },
})
export default class App extends Vue {}
